import { render, staticRenderFns } from "./latestincome.vue?vue&type=template&id=32317d5a&scoped=true"
import script from "./latestincome.vue?vue&type=script&lang=js"
export * from "./latestincome.vue?vue&type=script&lang=js"
import style0 from "./latestincome.vue?vue&type=style&index=0&id=32317d5a&prod&lang=less"
import style1 from "./latestincome.vue?vue&type=style&index=1&id=32317d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32317d5a",
  null
  
)

export default component.exports